import { useStanQuery } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';
import { getCustomerId } from '@/lib/api/stripe';

export const useCustomerId = () => {
    const { data, isLoading, error, refetch } = useStanQuery<string, Error>({
        queryKey: [QUERY_KEYS.STRIPE_CUSTOMER_ID],
        queryFn: getCustomerId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        meta: { error: { sentryMessage: '[STRIPE-CUSTOMER-ID] failed-to-fetch-customer-id' } },
    });

    return { data, isLoading, error, refetch };
};
